// eslint-disable-next-line
import axios from "axios";
import authen from "./authen";
import querystring from "querystring";

const httpService = {
  methods: {
    $post: function (url, params) {
      return axios({
        method: "post",
        url: url,
        headers: {
          "token": authen.getToken(),
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        data: params,
      })
    },

    $get: function (url, params) {
      return axios({
        method: "get",
        url: url,
        headers: {
          "token": authen.getToken(),
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "application/x-www-form-urlencoded",
        },
        params: params
      })
    },

    $put: function (url, params) {
      return axios({
        method: "put",
        url: url,
        headers: {
          "token": authen.getToken(),
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        paramsSerializer: params,
      })
    },
    $postFormData: function (url, params) {
      var bodyFormData = new FormData();
      Object.keys(params).forEach(key => {
        bodyFormData.append(key, params[key])
      })
      return axios.post(url, bodyFormData)
    },
    $getQuerystring: function (url, params) {
      return axios.get(`${url}?${querystring.stringify(params)}`)
    }
  }
};

export default httpService;



// WEBPACK FOOTER //
// ./src/utils/httpService.js